import { useState, useEffect } from 'react'

const CITIES = [
  'Buenos Aires',
  'Santiago',
  'Ciudad de México',
  'Bogotá',
  'Lima',
  'Montevideo',
  'Quito',
  'La Paz',
  'Caracas',
  'San José',
]

const NAMES = [
  'Sofía',
  'Valentina',
  'Isabella',
  'Camila',
  'Martina',
  'Mateo',
  'Santiago',
  'Matías',
  'Sebastián',
  'Lucas',
  'Ana',
  'Lucía',
  'Mariana',
  'Gabriela',
  'Diego',
  'Alejandro',
  'Daniel',
  'Fernanda',
  'Paula',
  'Javier',
]

export interface NotificationData {
  name: string
  city: string
  id: number
}

export const usePurchaseNotifications = () => {
  const [notification, setNotification] = useState<NotificationData | null>(
    null,
  )
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const showNotification = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)]
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)]

      setNotification({
        name: randomName,
        city: randomCity,
        id: Date.now(),
      })
      setIsVisible(true)

      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false)
      }, 4000)
    }

    // Initial delay
    const initialTimeout = setTimeout(() => {
      showNotification()
    }, 5000)

    // Loop
    const interval = setInterval(() => {
      // Random interval between 15 and 30 seconds
      const delay = 15000 + Math.random() * 15000
      setTimeout(showNotification, delay)
    }, 20000) // Base interval check

    return () => {
      clearTimeout(initialTimeout)
      clearInterval(interval)
    }
  }, [])

  return { notification, isVisible }
}
